import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

interface ModalProps {
  isOpen: boolean;
  toggle: () => void;
  title?: string;
  children: React.ReactNode;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  handleClear?: any;
}

const DashboardModal: React.FC<ModalProps> = ({
  isOpen,
  toggle,
  title = "Modal Title",
  children,
  onConfirm,
  confirmText = "Confirm",
  cancelText = "Cancel",
  handleClear,
}) => {
  return (
    <Modal className="custom-content-modal dashboard-modal" isOpen={isOpen} toggle={toggle} centered backdrop="static" keyboard={false}>
      <ModalHeader className={"text-start heading"}>{title}</ModalHeader>
      <ModalBody className="description">{children}</ModalBody>
      <ModalFooter className="dashboard-modal-actions">
        <button className="clear" onClick={handleClear}>
          {cancelText}
        </button>
        {onConfirm && (
          <button className={"apply"} onClick={onConfirm}>
            {confirmText}
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default DashboardModal;
